import { EdgeItemType } from 'data/types';
import { getEdgeOpeningLayout } from 'utils/edge-opening-layout';
import { openingBarStyle } from 'utils/opening-layout';
import {
  EdgeRunType,
  OpeningEdgeType,
  OpeningPlacementType
} from 'utils/opening-position-types';
import { openingBarColor } from 'utils/opening-visuals';
import OpeningDecoration from './opening-decoration';

type EdgeOpeningProps = {
  item: EdgeItemType;
  edge: OpeningEdgeType;
  offsetFt: number;
  run: EdgeRunType;
  placement?: OpeningPlacementType | null;
  zoom?: number;
  isDragging?: boolean;
  dragTransform?: { x: number; y: number } | null;
  interactive?: boolean;
  onContextMenu?: (event: React.MouseEvent) => void;
  rootRef?: (node: HTMLDivElement | null) => void;
  rootProps?: React.HTMLAttributes<HTMLDivElement>;
};

export default function EdgeOpening({
  item,
  edge,
  offsetFt,
  run,
  placement = null,
  zoom = 1,
  isDragging = false,
  dragTransform = null,
  interactive = false,
  onContextMenu,
  rootRef,
  rootProps
}: EdgeOpeningProps) {
  const { rest, live, inwardSign, translateX, translateY } =
    getEdgeOpeningLayout({
      item,
      edge,
      offsetFt,
      run,
      placement,
      zoom,
      dragTransform
    });
  const isInvalid = item.valid === false;
  let cursor = 'default';
  if (interactive) {
    cursor = isDragging ? 'grabbing' : 'grab';
  }

  return (
    <div
      ref={rootRef}
      data-edge-item
      className='absolute rounded-sm'
      style={{
        ...openingBarStyle(
          { ...live, left: rest.left, top: rest.top },
          translateX,
          translateY
        ),
        backgroundColor: openingBarColor(item.type),
        opacity: isDragging ? 0.85 : 1,
        cursor,
        pointerEvents: interactive ? 'auto' : 'none',
        zIndex: isDragging ? 40 : 1
      }}
      onContextMenu={interactive ? onContextMenu : undefined}
      {...rootProps}
    >
      <OpeningDecoration
        itemType={item.type}
        lengthPx={live.width}
        thicknessPx={live.height}
        inwardSign={inwardSign}
      />
      {isInvalid && (
        <span
          aria-label='Invalid attributes'
          className='pointer-events-none absolute -right-1 -top-1 h-2.5 w-2.5 rounded-full border border-white bg-red-500'
        />
      )}
    </div>
  );
}
